import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function VerifiedAuthor() {
  // Calculate date from 2 days ago
  const getFormattedDate = () => {
    const date = new Date();
    date.setDate(date.getDate() - 2);
    const day = date.getDate();
    const month = date.toLocaleString('default', {
      month: 'long'
    });
    const year = date.getFullYear();
    return `${month} ${day}, ${year}`;
  };
  return <div className="flex items-center justify-center my-6 border-t border-b border-black py-3" data-id="element-275">
      <div className="flex items-center" data-id="element-276">
        <div className="w-12 h-12 rounded-full bg-gray-200 mr-3 overflow-hidden" data-id="element-277">
          <img src="https://images.unsplash.com/photo-1559839734-2b71ea197ec2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80" alt="Dr. Sarah Johnson" className="w-full h-full object-cover" data-id="element-278" />
        </div>
        <div data-id="element-279">
          <div className="flex items-center" data-id="element-280">
            <p className="font-bold text-sm" data-id="element-281">Dr. Sarah Johnson, MD</p>
            <div className="flex items-center ml-2 text-blue-600" data-id="element-282">
              <CheckCircleIcon size={14} data-id="element-283" />
              <span className="text-xs ml-1" data-id="element-284">Verified</span>
            </div>
          </div>
          <p className="text-xs" data-id="element-285">
            Endocrinology Specialist • {getFormattedDate()}
          </p>
          <p className="text-xs" data-id="element-286">Peer-reviewed by The Thyroid Health Journal</p>
        </div>
      </div>
    </div>;
}